import { Options, Vue } from 'vue-class-component'
import frontSidebar from '@/components/Frontend/Sidebar/index.vue'
import SimpleCalendar from '@/components/Frontend/SimpleCalendar/index.vue'
import axios from 'axios'
import { mediaBaseURL } from '@/components/Utility/Base'
import SponsorsDataService from '@/services/SponsorsDataService'
import { Posts } from '@/services/PostsDataService'
import fallbackImg from '@/assets/img/img_fallback_.jpg'
import LeftSideBar from '@/components/Frontend/LeftSideBar/index.vue'

@Options({
  components: {
    frontSidebar,
    SimpleCalendar,
    LeftSideBar
  }
})

export default class NewsGrid extends Vue {
  readonly mediaBaseUrl : string = mediaBaseURL
  private newsItems: Array<any> = []
  public sponsorsList: Array<any> = []

  formatDate (isoDate:string):string {
    const date = new Date(isoDate)
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    const formattedDate = date.toLocaleDateString('en-US', options)
    return formattedDate
  }

  redirectTo (link:string) {
    if (!link) return

    try {
      const url = new URL(link)
      window.location.href = url.href
    } catch (e) {
      console.log('error: invalid url ', link, e)
    }
  }

  extractImgUrl (content: any) {
    const html = content?.indlaeg_versionerings_id?.[content?.indlaeg_versionerings_id.length - 1]?.indlaeg_versionering_indhold ?? ''
    const urls = new Set()

    const combinedRegex = /<img[^>]+src=["']([^"']+\.(?:jpg|jpeg|png|gif|webp|svg))["']|https?:\/\/[^\s"'<>]+?\.(?:jpg|jpeg|png|gif|webp|svg)/gi
    let match

    while ((match = combinedRegex.exec(html)) !== null) {
      urls.add(match[1] || match[0])
    }
    const res = Array.from(urls)[0]
    return res
  }

  public async getSponsorsData ():Promise<void> {
    try {
      const response = await SponsorsDataService.getPopulatedData()
      if (response?.data) this.sponsorsList = response.data.filter((data:any) => data.sponsor_forside ? true : false)
    } catch (error) {
      console.error('Failed to fetch sponsors', error)
    }
  }

  public viewAllPost () {
    this.$router.push({
      name: 'Nyhedsarkiv'
    })
  }

  public viewPostById (item: any) {
    console.log(item, 'item >>>>>>>>>>')
    this.$router.push({
      name: 'Indlaeg_type',
      params: { indlaeg_type: item?.indlaeg_kategori_id?.indlaeg_kategori_titel, indlaegSlug: item.indlaeg_slug }
    })
  }

  public async getNewsData ():Promise<void> {
    try {
      const response = await Posts.PostsDataService.getPopulatedData()
      if (response?.data) {
        this.newsItems = response.data.slice(0, 6)
      }
    } catch (error) {
      console.error('Failed to fetch indlaegs data', error)
    }
  }

  public async getCategoryData ():Promise<void> {
    try {
      const response = await Posts.PostsDataService.getPopulatedData()
      if (response?.data) {
        this.newsItems = response.data.slice(0, 6)
      }
    } catch (error) {
      console.error('Failed to fetch indlaegs data', error)
    }
  }

  async mounted ():Promise<void> {
    await Promise.all([this.getSponsorsData(), this.getNewsData()])
    this.getCategoryData()
  }
}
